module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "formRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.searchForm,
      "inline": true,
      "label-position": 'right',
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券名称"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.couponName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "couponName", $$v)
      },
      expression: "searchForm.couponName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠券类型"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.searchForm.couponType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "couponType", $$v)
      },
      expression: "searchForm.couponType"
    }
  }, _vm._l((_vm.couponTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消费方式"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.searchForm.consumeType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "consumeType", $$v)
      },
      expression: "searchForm.consumeType"
    }
  }, _vm._l((_vm.couponConsumeTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "领取方式"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.searchForm.receiveType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "receiveType", $$v)
      },
      expression: "searchForm.receiveType"
    }
  }, _vm._l((_vm.couponReceiveTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期类型"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.searchForm.validityType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "validityType", $$v)
      },
      expression: "searchForm.validityType"
    }
  }, _vm._l((_vm.couponValidityTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠券状态"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.searchForm.status),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "status", $$v)
      },
      expression: "searchForm.status"
    }
  }, _vm._l((_vm.couponStatusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.loadPage(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.gotoSubscriberCoupon
    }
  }, [_vm._v("会员优惠券")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.couponList,
      "border": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "50",
      "center": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "优惠券名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "column-key": "type",
      "label": "优惠券类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "consumeTypeName",
      "label": "消费方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receiveTypeName",
      "label": "领取方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "validityTypeName",
      "label": "有效期类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "优惠券面额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "发放总量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "received",
      "label": "已领取数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusName",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "创建时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modified",
      "label": "更新时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false,
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.openCouponHistory(scope.row)
            }
          }
        }, [_vm._v("\n          领取记录")]), _vm._v(" "), _c('el-divider', {
          attrs: {
            "direction": "vertical"
          }
        }), _vm._v(" "), _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false,
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.publishCoupon(scope.row)
            }
          }
        }, [_vm._v("\n          发放优惠券")]), _vm._v(" "), _c('el-divider', {
          attrs: {
            "direction": "vertical"
          }
        }), _vm._v(" "), _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false,
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.generateCoupon(scope.row)
            }
          }
        }, [_vm._v("\n          生成记录")]), _vm._v(" "), _c('el-divider', {
          attrs: {
            "direction": "vertical"
          }
        }), _vm._v(" "), _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false,
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.searchForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.searchForm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.searchForm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('coupon-history', {
    ref: "couponHistoryRef"
  }), _vm._v(" "), _c('publish-coupon', {
    ref: "publishCouponRef",
    on: {
      "close": _vm.loadPage
    }
  }), _vm._v(" "), _c('generate-coupon', {
    ref: "generateCouponRef"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-cd3ed478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/coupon/index.vue
// module id = 1750
// module chunks = 0